import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';
import { DateSelectService } from './date-select.service';

@Injectable({
  providedIn: 'root'
})
export class DemandReductionDataService {

  // Set up flow BehaviorSubject
  private demandReductionSource = new BehaviorSubject<DemandReductionReach[]>([]);
  currentDemandReduction = this.demandReductionSource.asObservable();

  excessFlowDate: string;

  constructor(private http: HttpClient, private dateSelectObject: DateSelectService, @Inject('BASE_URL') private baseUrl: string) {

    // Whenever you get a date, grab the DemandReduction data
    this.dateSelectObject.currentDate.subscribe((result) => {

      this.excessFlowDate = result;
      this.getDemandReduction();

    });

  }

  // Call API to get new DemandReduction data

  getDemandReduction() {
    this.http.get<DemandReductionReach[]>(`${this.baseUrl}api/DemandDetail/${this.excessFlowDate}/`).subscribe(

      result => {
        if (result) {
          this.changeDemandReduction(result);
        }
      },
      error => console.error(error)
    );
  }

  // Update DemandReduction BehaviorSubject
  changeDemandReduction(demandReduction) {
    this.demandReductionSource.next(demandReduction);
  }

}

export interface DemandReductionStation {
  actualDemand: number;
  adjustedDemand: number;
  demandConditionName: string;
  demandEntityId: number;
  demandEntityName: string;
  demandType: string;
  dssStationName: string;
  dssStationNumber: string;
  notes: string;
  potentialDemand: number;
  reachNumber: number;
  reduction: number;
}

export interface DemandReductionReach {
  adjustedDemandSubtotal: number;
  potentialDemandSubtotal: number;
  reductionSubtotal: number;
  stations: DemandReductionStation[];
}
